import type { KnownRouteSegmentMetadata } from '@/shared/types';

import { getRouteBySegment } from '../../routes/routeConfig';

export { getPortalAppDefinition, navigationConstants } from '@/shared/constants';

export const getKnownRouteSegmentMetadata = (segment: string): KnownRouteSegmentMetadata | undefined => {
  const route = getRouteBySegment(segment);
  if (!route) return undefined;
  return { label: route.label, icon: route.icon };
};
